const lang = {
  confirm_application_detail: 'お申込み内容確認',
  customer_information: 'お申込み内容',
  contract: '個別契約',
  duration: '有料アカウント（１年間）',
  price_amount: '単価：¥26,400-（税込）',
  application_info: 'お申込者情報',
  application: '申込み',
  return_to_account: 'アカウントページに戻る',
  complete_paid_plan: ' 有料アカウント申込み完了',
  content_success: '３営業日以内に、メールにて請求書を送付いたします。受領されましたら、７営業日以内に銀行振込のお手続きをよろしくお願い申し上げます。<br> <br>ご入金の確認が取れ次第、有料アカウントの利用手続きを行います。'
}

export default lang;



// WEBPACK FOOTER //
// ./src/lang/ja/pages/confirmationApplicationDetails.js